module.exports = __webpack_public_path__ + "img/EmoQi-Cover-FeMale.17a27f97.gif";